// Atualizar ChannelConfigure.js - Adicionar suporte para múltiplos tipos

import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { channelService } from '../../services/PlatformService';

// Import configuration components for each channel type
import ConfigureWhatsAppBusiness from '../../components/channels/ConfigureWhatsAppBusiness';
import ConfigureWhatsAppQR from '../../components/channels/ConfigureWhatsAppQR';
import ConfigureInstagram from '../../components/channels/ConfigureInstagram';
import ConfigureMessenger from '../../components/channels/ConfigureMessenger';

const ChannelConfigure = () => {
  const { channelId } = useParams();
  const navigate = useNavigate();
  const [channel, setChannel] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadChannel();
  }, [channelId]);

  const loadChannel = async () => {
    try {
      setLoading(true);
      const response = await channelService.getChannel(channelId);
      const channelData = response.data;
      setChannel(channelData);
    } catch (error) {
      console.error('Error loading channel:', error);
      alert('Erro ao carregar canal');
      navigate('/channels');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-green-600" />
      </div>
    );
  }

  // Redirect based on channel type
  const renderConfigurationComponent = () => {
    switch (channel.type) {
      case 'whatsapp_business':
        return <ConfigureWhatsAppBusiness channel={channel} onUpdate={loadChannel} />;
      
      case 'whatsapp_qr':
        return <ConfigureWhatsAppQR channel={channel} onUpdate={loadChannel} />;
      
      case 'instagram_direct':
        return <ConfigureInstagram channel={channel} onUpdate={loadChannel} />;
      
      case 'messenger':
        return <ConfigureMessenger channel={channel} onUpdate={loadChannel} />;
      
      default:
        return (
          <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-blue-50">
            <div className="bg-white shadow-sm">
              <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
                <button
                  onClick={() => navigate('/channels')}
                  className="p-2 hover:bg-gray-100 rounded-xl transition-all"
                >
                  <ArrowLeft className="w-6 h-6" />
                </button>
                <h1 className="text-2xl font-bold text-gray-900">
                  Configurar {channel?.name}
                </h1>
              </div>
            </div>
            
            <div className="max-w-4xl mx-auto px-4 py-8">
              <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
                <h2 className="text-xl font-bold text-gray-900 mb-4">
                  Tipo de Canal Não Suportado
                </h2>
                <p className="text-gray-600 mb-6">
                  A configuração para o tipo de canal "{channel.type}" ainda não está disponível.
                </p>
                <button
                  onClick={() => navigate('/channels')}
                  className="px-6 py-3 bg-green-600 text-white rounded-xl font-medium hover:bg-green-700 transition-all"
                >
                  Voltar aos Canais
                </button>
              </div>
            </div>
          </div>
        );
    }
  };

  return renderConfigurationComponent();
};

export default ChannelConfigure;